<template>
  <embeddable-footer :sharing-options-values="{title: socialTitle}" :lead="leadApp" :title="titleApp" :home-url="urlApp" ></embeddable-footer>
</template>

<script>
  import { EmbeddableFooter } from '@icij/murmur'

  export default {
    name: 'IncidentsFooter',
    components: {
      EmbeddableFooter
    },
    data() {
      return {
        showFooter: false
      }
    },
    props: {
      titleApp: null,
      leadApp: null,
      urlApp: null, 
      textApp: null,
      urlShare: null,
      socialTitle: null
    },
  }
</script>


<style lang="scss">

  @import 'node_modules/@icij/murmur/lib/styles/lib.scss';
  @import 'node_modules/@icij/murmur/lib/styles/mixins.scss';
  @import 'node_modules/@icij/murmur/lib/styles/variables.scss';
  @import 'node_modules/@icij/murmur/lib/styles/functions.scss';
  
  @include keyframes(slideup) {
    0% {
      transform: translateY(100%);
      opacity:0;
    }
    100% {
      transform: translateY(0%);
      opacity:1;
    }
  }

  .embeddable-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    z-index: $zindex-sticky;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: black;
    color: white;
    // Magic technique to have a minimum font-size (10px-ish)
    font-size: calc(10px + 1.5vh);
    @media screen and (min-height: 800px) {
      font-size: 1rem;
    }
    &__brand {
      padding-right: $spacer;
      margin-right: $spacer;
      border-right: 2px solid white;
      font-family: $headings-font-family;
      font-size: 1.1em;
    }
    &__lead {
      flex-grow: 1;
      min-width: 0;
      font-size: 0.9em;
    }
    &__share-btn {
      border:1px solid transparent;
      height: 2.5em;
      line-height: 2.5em;
      width: 2.5em;
      font-size: 80%;
      text-align: center;
      border-radius: 50%;
      &.active {
        border-color: white;
      }
      &:hover {
        background: rgba(white, .1);
      }
    }
    & /deep/ .sharing-options {
      position: absolute;
      bottom: 100%;
      right: 0;
      margin: $spacer * 0.25;
      &__link {
        opacity: 0;
        animation:slideup 200ms forwards;
        @include animation-delay-loop(0, 10, 50ms);
      }
    }

    .text-dark {
      background: #31343c;
    }

    .text-dark .modal {
      padding: 10px;
      font-family: 'Lato', sans-serif;
    }

    .text-dark .modal .modal-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .text-dark .modal .modal-header h5 {
      width: 100%;
      font-weight: 900;
    }

    .text-dark .modal textarea {
      display: block;
      width: 95%;
      margin: 10px auto;
    }
  }
</style>